import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import WelcomePage from "./WelcomePage";
import Login from "./Login";
import AdminLogin from "./AdminLogin";
import LoginSignupPage from "./LoginSingupPage";
import Invoice from "./Invoice";
import Bill from "./Bill";
import ProductCard from "./ProductCard";
import UpdateProductPage from "./UpdateProductPage";
import SetProduct from "./SetProduct";
import ProductManagement from "./components/ProductManagement";
import Accounts from "./components/Accounts";
import ProductWarning from "./ProductWarning";
import BillHistory from "./components/BillHistory";
import WorkerManagement from "./components/WorkerManagement";
import WorkersAttendance from "./components/WorkerAttendance";

function App() {
  // Initialize from localStorage
  const [isAdmin, setIsAdmin] = useState(() => {
    // Always return a boolean
    return localStorage.getItem("isAdmin") === "true";
  });

  // Sync localStorage when isAdmin changes
  useEffect(() => {
    localStorage.setItem("isAdmin", isAdmin ? "true" : "false");
  }, [isAdmin]);

  // Handler for user login
  const handleUserLogin = () => {
    setIsAdmin(false);
    localStorage.setItem("isAdmin", "false");
  };

  // Handler for admin login
  const handleAdminLogin = () => {
    setIsAdmin(true);
    localStorage.setItem("isAdmin", "true");
  };

  return (
    <Router>
      {isAdmin ? (
        <>
          <Header setIsAdmin={setIsAdmin} />
          <Routes>
            <Route path="/bill-history" element={<BillHistory />} />
            <Route path="/add-workers" element={<WorkerManagement />} />
            <Route path="/accounts" element={<Accounts />} />
            <Route path="/product-management" element={<ProductManagement />} />
            <Route path="/workers-attendance" element={<WorkersAttendance />} />
            <Route path="/" element={<h2 style={{ textAlign: "center" }}>Welcome to Admin Panel</h2>} />
          </Routes>
        </>
      ) : (
        <Routes>
          <Route path="/" element={<WelcomePage />} />
          <Route path="/login" element={<Login onLogin={handleUserLogin} />} />
          <Route path="/admin-login" element={<AdminLogin onLogin={handleAdminLogin} />} />
          <Route path="/login-signup" element={<LoginSignupPage />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/bill" element={<Bill />} />
          <Route path="/product" element={<ProductCard />} />
          <Route path="/up-product" element={<UpdateProductPage />} />
          <Route path="/set-product" element={<SetProduct />} />
          <Route path="/report" element={<ProductWarning />} />
        </Routes>
      )}
    </Router>
  );
}
export default App;